import { loginOut } from '@/api/account';
import { SensorsProvider } from '@/reporting/providers/sensorProvider';
import { ReportingCenter } from '@/reporting/reportingCenter';
import { ProviderType } from '@/reporting/types';
import { recordIdentityError, recordIdentityLifecycle } from '@/reporting/identityDiagnostics';
import logger from '@/utils/client-logger';
import { visitor } from '@/utils/tools';

// 访问store实例进行状态清理
let getStoreInstance: (() => any) | null = null;

// 设置store实例的访问函数
export function setStoreAccessor(accessor: () => any) {
  getStoreInstance = accessor;
}

// 清理store中与登录相关的数据
function clearStoreLoginData() {
  if (!getStoreInstance) return;

  try {
    const store = getStoreInstance();
    if (store) {
      // 清理用户相关数据
      store.setToken('');
      store.setUserInfo({});
      store.setVisitorId(visitor());

      // 清理购物车相关数据
      store.setCanBuyList([]);
      store.setCanBuyCartsList([]);
      store.setCanNotBuyList([]);
      store.setSelectedCartIds([]);

      // 清理其他登录相关数据
      store.setLoginSituation('');
      store.setWishNum(0);
    }
  } catch (error) {
    logger.error('Failed to clear store login data:', error);
  }
}

/** 保留原有 storage 异常语义，同时补充退出阶段的身份诊断。 */
function clearLogoutIdentityStorage(): void {
  try {
    localStorage.removeItem('zl-token');
    localStorage.setItem('zl-visitor_id', visitor());
    recordIdentityLifecycle('logout_storage_finished');
  } catch (error) {
    recordIdentityError('logout_storage');
    throw error;
  }
}

/**
 * 独立的退出登录函数，可以在非组件环境中使用
 * 这个函数不依赖于React Hook，可以在axios拦截器等地方直接调用
 */
export async function performLogout(options: { shouldCallLogouApi?: boolean } = {}) {
  const { shouldCallLogouApi = true } = options;
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '/';
  recordIdentityLifecycle('logout_started');

  try {
    // 调用后端退出登录接口
    if (shouldCallLogouApi) {
      await loginOut();
    }

    // 神策退出登录
    const center = ReportingCenter.getInstance();
    const sensorsProvider = center.getProvider(ProviderType.SENSORS) as SensorsProvider;
    if (sensorsProvider) {
      sensorsProvider.sensorsLogout();
    }
  } catch (error) {
    logger.error('Failed to logout:', error);
  } finally {
    // 清除本地存储的登录状态
    // 立即清除本地状态
    clearLogoutIdentityStorage();
    sessionStorage.removeItem('zl-login-situation-new');

    // 清除cookie中的token
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

    // 清理store中的登录相关数据
    clearStoreLoginData();

    // 如果在浏览器环境且需要重定向
    if (typeof window !== 'undefined') {
      // 如果当前页面是价格差异页面，则不跳转
      if (!pathname?.startsWith('/price-difference') && pathname !== '/') {
        window.location.href = '/';
      }
    }
  }
}
